export default __webpack_public_path__ + "carco-web.webp";